import { msg } from '@lingui/core/macro';

import { defineFilters } from '@/shared/filters/define-filters';

// Um só filtro no legado: "Nome" → searchString (SystemApplicationListContainer.tsx:83–86).
export const systemApplicationFilters = defineFilters([
  { key: 'searchString', type: 'text', label: msg`Nome`, placeholder: msg`Filtrar por nome` },
]);
